import log from 'loglevel'
import { HeatmapLayer } from '@deck.gl/aggregation-layers'
import VARIABLES from '@/assets/scss/variables.module.scss'
import ColorUtil from '@/js/util/ColorUtil.js'

// レイヤーID
const LAYER_ID = 'heatmap'

// デフォルトのカラーレンジ
const COLOR_RANGE = [
  VARIABLES.ENTITY_COLOR_NAVY,
  VARIABLES.ENTITY_COLOR_BLUE,
  VARIABLES.ENTITY_COLOR_LIGHT_GREEN,
  VARIABLES.ENTITY_COLOR_GOLD,
  VARIABLES.ENTITY_COLOR_RED,
].map((c) => [...ColorUtil.hexToRgb(c), 204])

/**
 * 0〜1の範囲に丸める
 * @param {Number} value 値
 * @returns 丸め後値
 */
const clampZeroOne = (value) => {
  if (+value < 0) {
    return 0
  } else if (+value > 1) {
    return 1
  } else {
    return +value
  }
}

/**
 * ヒートマップのレンダラー
 */
class HeatmapRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * デフォルトのカラーレンジ
   * @returns {Array.<Array.<Number>>}
   */
  static DEFAULT_COLOR_RANGE() {
    return COLOR_RANGE
  }

  /**
   * コンストラクタ
   * @param {Array.<Array.<Number>>} colorRange カラーレンジ
   * @param {Number} threshold カラーレンジの下限閾値(0〜1)
   */
  constructor({ colorRange, threshold } = {}) {
    this.colorRange = colorRange || COLOR_RANGE
    this.threshold = threshold == null ? 0.1 : clampZeroOne(threshold)
  }

  /**
   * レンダラー関数を作成する
   * @param {Object|Function} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<HeatmapLayer>}
   */
  createRenderer(data, props) {
    log.debug('HeatmapRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () =>
        new HeatmapLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          threshold: this.threshold,
          colorRange: this.colorRange,
          weightsTextureSize: 512,
          getPosition: (d) => d.coordinates,
          parameters: {
            blend: true,
            depthRange: [0, 0.89],
          },
          ...props,
        }),
    }
  }
}

HeatmapRenderer.LAYER_ID = LAYER_ID

export default HeatmapRenderer
